import React from 'react';
import PropTypes from 'prop-types';

const PAGE_SIZE = 1;

import { useGetRoundsQuery } from 'common/store/modules/api/afl-api';
import { TeamIcon } from './TeamIcon';
import { getTranslation } from '../utils/translations';

export const ByesGroup = ({ compseasonId, roundNumber }) => {
    const { byesData } = useGetRoundsQuery(
        {
            compseasonId: compseasonId,
            params: {
                roundNumber: roundNumber,
                pageSize: PAGE_SIZE
            }
        },
        {
            selectFromResult: ({ data }) => ({
                byesData: data?.[0]?.byes || []
            })
        }
    );

    const renderByes = () => {
        return byesData.map((item) => (
            <TeamIcon
                key={item.id}
                className="byes__bye-fixture"
                providerId={item.providerId}
            />
        ));
    };

    return (
        <>
            {byesData.length > 0 && (
                <div className="byes">
                    <h2 className="byes__date-header">
                        {getTranslation('label.fixtures.byeRound')}
                    </h2>
                    <div className="byes__bye-fixtures">{renderByes()}</div>
                </div>
            )}
        </>
    );
};

ByesGroup.propTypes = {
    compseasonId: PropTypes.number.isRequired,
    roundNumber: PropTypes.number.isRequired
};
